<!-- <div style="position: fixed;  top: 0px;  left: 200px;  background: #e75c25;  z-index: 1000;  text-transform: uppecase;  padding: 0 13px;  color: white;">test version</div> -->
<tt-header #ttHeader class="tt-header">

  <!-- content in mobile drawer *ngIf="browserSniffer.isMobile()" -->
  <div style="display:contents;" [ngClass]="{ hide: !browserSniffer.isMobile() }" mobileContentDrawerTemplate>
    <div style="margin-top:16px">
      <mat-nav-list class="map-command-list">
        @if (browserSniffer.isPhone()) {
        <mat-list-item (click)="ttHeader.toggle();traceService.openImportDialog()">
          <mat-icon matListItemIcon fontSet="ngi" fontIcon="route-upload"></mat-icon>
          <div matListItemTitle>{{ "trace.import-route.title" | translate }}</div>
        </mat-list-item>
        }

        @if (browserSniffer.isPhone()) {
        <mat-list-item (click)="ttHeader.toggle();traceService.openCreateMobile(false)">
          <mat-icon matListItemIcon fontSet="ngi" fontIcon="route-draw"></mat-icon>
          <div matListItemTitle>

            <!-- we only use 2 statuses for the text at this moment: draw route(not active) & draw new route(view or editing mode)
              we could use 3 statuses: draw(not active), edit(view mode), draw new(editing mode)
              !traceService.isInViewMode() && !traceService.isInEditingMode() ? ("trace.create-route.title" | translate) : traceService.isInViewMode() ? ("trace.create-route.subtitle-old" | translate) : ("trace.create-route.subtitle-new" | translate)
              the click event should also be updated then
              traceService.openCreateMobile with value true or false depending on the situation -->

            {{ !traceService.isInViewMode() && !traceService.isInEditingMode() ? ("trace.create-route.title" |
            translate) : ("trace.create-route.subtitle-new" | translate) }}
            <!-- <span style="color:#2fa298;position:absolute;left:40px;top:3px;font-size:13px">NEW</span> -->
          </div>
        </mat-list-item>
        }



        @if (browserSniffer.isPhone()) {
        <mat-list-item (click)="ttHeader.toggle(); measure.togglePanel($event)">
          <mat-icon matListItemIcon fontSet="ngi" fontIcon="measure"></mat-icon>
          <div matListItemTitle>{{ "measure.title" | translate }}</div>
        </mat-list-item>
        }

        @if (browserSniffer.isPhone()) {
        <mat-list-item (click)="ttHeader.toggle(); legend.openDialog()">
          <mat-icon matListItemIcon fontSet="ngi" fontIcon="tree-deciduous"></mat-icon>
          <div matListItemTitle>{{ "legendTxt.title" | translate }}</div>
        </mat-list-item>
        }
        @if (browserSniffer.isPhone()) {
        <mat-list-item [ngClass]="{disabled: !sendRemark.canCommentMap}" (click)="ttHeader.toggle();sendRemark.open()">
          <mat-icon matListItemIcon fontSet="ngi" fontIcon="remarks"></mat-icon>
          <div matListItemTitle>{{'send-remark.title'|translate}}</div>
        </mat-list-item>
        }
        <!--  (click)="sendRemark.canCommentMap ? sendRemark.setMapRemarksInteraction():sendRemark.showCannotCommentMsg($event.target)" -->

        @if (browserSniffer.isPhone()) {
        <mat-divider></mat-divider>
        }

        <mat-list-item (click)="ttHeader.close(); pdfService.open()">
          <mat-icon matListItemIcon>print</mat-icon>
          <div matListItemTitle>PDF</div>
        </mat-list-item>

        <mat-list-item (click)="ttHeader.close(); shareMap.openDialog()">
          <mat-icon matListItemIcon>share</mat-icon>
          <div matListItemTitle>{{ "share.shareMap" | translate }}</div>
        </mat-list-item>

        <mat-list-item mat-icon-button (click)="themeSwitch.switchTheme()" disableRipple>
          @if (!themeSwitch.darkActive()) {
          <mat-icon matListItemIcon class="primary-button">light_mode</mat-icon>
          }
          @if (themeSwitch.darkActive()) {
          <mat-icon matListItemIcon>dark_mode</mat-icon>
          }
          @if (themeSwitch.darkActive()) {
          <div matListItemTitle>
            {{ "themeswitch.tolightmode" | translate }}
          </div>
          }
          @if (!themeSwitch.darkActive()) {
          <div matListItemTitle>
            {{ "themeswitch.todarkmode" | translate }}
          </div>
          }
        </mat-list-item>
        <tt-share-map [showAsIcon]="false" #shareMap></tt-share-map>
      </mat-nav-list>
      <mat-divider></mat-divider>
      <tt-language-chooser [showAsIcon]="false" #languageChooser></tt-language-chooser>
    </div>
    <div class="drawer-footer">
      <div class="ngi-logo-thumb"></div>
      <div class="copyright-txt">NGI © IGN {{ currentYear }}</div>
    </div>
  </div>
  <!-- content in mobile toolbar -->
  <div [ngClass]="{ hide: !browserSniffer.isMobile() }" mobileToolbarTemplate style="display: contents">
    <div logoTemplate style="display: contents">
      <tt-logo></tt-logo>
    </div>
  </div>
  <!-- content in desktop toolbar -->
  <div [ngClass]="{ hide: browserSniffer.isMobile() }" desktopToolbarTemplate style="display: contents">
    <div logoTemplate style="display: contents">
      <tt-logo></tt-logo>
    </div>
    <span class="spacer"></span>
    <div class="icon-wrapper">
      <button matIconButton class="primary-button">
        <mat-icon [matTooltip]="
          languageChooser.languageService.languages[
            languageChooser.languageService.selectedLang() || 'en'
          ]
        " [matMenuTriggerFor]="languageChooser.menu" #languageChooserTriggerBtn="matMenuTrigger"
          (menuOpened)="languageChooser.menuOpened(languageChooserTriggerBtn)">
          language
        </mat-icon>
      </button>
      <button matIconButton class="primary-button" matTooltip="PDF/Print" (click)="pdfService.open()"
        aria-hidden="false"><mat-icon>print</mat-icon></button>

      <button matIconButton class="primary-button">
        <mat-icon [matTooltip]="'share.shareMap' | translate" (click)="shareMap.openDialog()"
          aria-hidden="false">share</mat-icon>
      </button>

      <button matIconButton class="primary-button" (click)="themeSwitch.switchTheme()">
        @if (themeSwitch.darkActive()) {
        <mat-icon [matTooltip]="'themeswitch.tolightmode' | translate">light_mode</mat-icon>
        }
        @if (!themeSwitch.darkActive()) {
        <mat-icon [matTooltip]="'themeswitch.todarkmode' | translate">dark_mode</mat-icon>
        }
      </button>

    </div>
  </div>
  <!-- content in common toolbar -->
  <div toolbarTemplate style="display: contents">
    <div class="geocoding-overlay open" id="geocodingOverlay" [ngClass]="{ open: geocoding.isOpen() }">
      <!-- < tt-geocoding-v2 [openOnLargeScreen]="browserSniffer.isPhone() ? false : true" #geocoding>< / tt-geocoding-v2 >-->
       <tt-geocoding [openOnLargeScreen]="browserSniffer.isPhone() ? false : true" #geocoding></tt-geocoding>
    </div>
  </div>
</tt-header>



<!-- <tt-offline-map></tt-offline-map> -->



<!-- map -->
<tt-map #ttMap targetId="'ttMap'"></tt-map>
<tt-theme-switch #themeSwitch [showAsIcon]="false"></tt-theme-switch>
<!-- <tt-share-map [showAsIcon]="false" #shareMap></tt-share-map> -->
<!-- baselayerselector -->
<tt-base-layer-theme-selector [showAsIcon]="true"></tt-base-layer-theme-selector>
<!-- legend -->
<tt-legend></tt-legend>
<!-- send remark -->
<tt-send-remark #sendRemark></tt-send-remark>
<!-- measure (now added to tt-trace-select) -->
<tt-measure #measure></tt-measure>
<!-- mouseposition -->
<tt-mouse-position class="tt-mouse-position"></tt-mouse-position>
<!-- mouseposition for mapsheets -->
<!-- <tt-mouse-position-mapsheets></tt-mouse-position-mapsheets> -->
<!-- zoom and geolocation -->
<tt-zoom [axis]="'vertical'" class="tt-zoom"></tt-zoom>
<!-- trace  -->
<!-- <tt-trace-drawer></tt-trace-drawer> -->
<!-- -->
@if (!browserSniffer.isPhone()) {
<tt-trace hideTraceCreate="false" hideSuggestions="true"></tt-trace>
}
<tt-drawing-tools></tt-drawing-tools>
<tt-alert></tt-alert>

<!-- <tt-drawing-tools></tt-drawing-tools> -->

<!-- <div style="z-index: 999;position: absolute;top:660px;padding:15px;border-radius: 6px;left:100px;right:100px;background: rgba(255, 217, 0, 0.5);">
  <button color="warn" mat-flat-button (click)="traceService.openCreateMobile()" style="margin: 5px;">
    Open Create
  </button>
  <br>
  </div>   -->
@if (showTraceViewBtn()) {
<div class="info-route-button-container">
  @if (browserSniffer.isPhone() && showTraceViewBtn()) {
  <button mat-flat-button class="" aria-label="info route" class="orange-button"
    (click)="traceService.openViewDialog();">
    <mat-icon fontSet="ngi" fontIcon="route-view"></mat-icon>&nbsp;&nbsp;{{ 'trace.info-route-btn' | translate }}
  </button>
  }
</div>


}

<!-- elevation profile  -->
<tt-elevation-profile [autoOpenOnData]="false" [autoCloseOnNoData]="browserSniffer.isPhone()"></tt-elevation-profile>
<!-- notification -->
<!-- <tt-notification></tt-notification> -->
<!---->
<div class="atrributions flex-container row container-flex-end">
  <div class="ngi-logo-thumb ngi-logo-thumb-bg background"
    alt="nationaal geografisch instituut - institut géographique national"
    title="nationaal geografisch instituut - institut géographique national"></div>
  <div class="copyright-txt">
    <span class="">NGI © IGN {{ currentYear }}
      <a href="{{ 'general.terms_of_use_url' | translate }}" target="_blank">{{
        "general.terms_of_use" | translate
        }}</a></span>
    <span class="hideAttributionFromLevel hide">©2006-{{ currentYear }}_TomTom</span>
    <span class="hideAttributionFromLevel-2 hide">©EuroGeographics</span>
  </div>
</div>